import React from "react";
//Limitless imports
import { useSecurityProfileHook } from "../../../../expert/hooks/security-profile/SecurityProfileHook";
import ExpertConversationFinalDialog from "../../expert-conversation/dialogue/expert-conversation-final-dialog/ExpertConversationFinalDialog";
const SecurityProfileChangeDialog = () => {
  const {
    securityProfileChanged,
    confirmChange
  } = useSecurityProfileHook();
  if (!securityProfileChanged) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ExpertConversationFinalDialog, {
    buttonText: "Confirm",
    onFinishClick: confirmChange,
    title: "Security Profile Changed",
    body: "The system administrator has just changed your security profile and you must sign back in."
  });
};
export default SecurityProfileChangeDialog;